import { __decorate } from "tslib";
import { provide } from '@lit/context';
import { localized } from '@lit/localize';
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { createValidity } from '../../shared/forms/form-utils.js';
import { HelixValidatable } from '../../shared/forms/helix-validatable.js';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { formControlStyles } from '../../shared/styles/form-control.styles.js';
import '../icon/icon.js';
import { checkboxGroupDisabledContext, checkboxGroupReadonlyContext, } from './checkbox-group-context.js';
import { checkboxGroupStyles } from './checkbox-group.styles.js';
let HlxCheckboxGroup = class HlxCheckboxGroup extends HelixValidatable {
    constructor() {
        super(...arguments);
        this.errorText = '';
        this.type = 'column';
        this.label = '';
        this.description = '';
        this.disabled = false;
        this.readonly = false;
    }
    render() {
        return html `
            <fieldset
                part="hlx-checkbox-group-fieldset"
                ?disabled="${this.disabled}"
                class="${classMap({
            ...this.validation.classMap,
            'hlx-form-control-md': true,
            'hlx-checkbox-group-fieldset': true,
        })}">
                <slot name="label" part="label" class="hlx-checkbox-group-label">
                    ${this.label}
                </slot>
                <slot name="description" part="description" class="hlx-checkbox-group-description">
                    ${this.description}
                </slot>
                <slot
                    part="base"
                    class="${classMap({
            'hlx-checkbox-group': true,
            'hlx-checkbox-group-column': this.type === 'column',
            'hlx-checkbox-group-row': this.type === 'row',
        })}"></slot>
                ${this.validation.renderErrorSlot('hlx-checkbox-group-error')}
            </fieldset>
        `;
    }
    get validity() {
        if (this.validation.hasCustomValidity) {
            return createValidity('customError');
        }
        return createValidity();
    }
    focus(options) {
        const first = this.baseSlot.assignedElements()[0];
        if (first && 'focus' in first && typeof first.focus === 'function') {
            first.focus(options);
        }
    }
    getDefaultErrorMessage() {
        return '';
    }
};
HlxCheckboxGroup.styles = [componentStyles, checkboxGroupStyles, formControlStyles];
__decorate([
    property({ type: String, attribute: 'error-text' })
], HlxCheckboxGroup.prototype, "errorText", void 0);
__decorate([
    property({ type: String })
], HlxCheckboxGroup.prototype, "type", void 0);
__decorate([
    property({ type: String })
], HlxCheckboxGroup.prototype, "label", void 0);
__decorate([
    property({ type: String })
], HlxCheckboxGroup.prototype, "description", void 0);
__decorate([
    provide({ context: checkboxGroupDisabledContext }),
    property({ type: Boolean, reflect: true })
], HlxCheckboxGroup.prototype, "disabled", void 0);
__decorate([
    provide({ context: checkboxGroupReadonlyContext }),
    property({ type: Boolean, reflect: true })
], HlxCheckboxGroup.prototype, "readonly", void 0);
__decorate([
    query('[part="base"]')
], HlxCheckboxGroup.prototype, "baseSlot", void 0);
HlxCheckboxGroup = __decorate([
    customElement('hlx-checkbox-group'),
    localized()
], HlxCheckboxGroup);
export { HlxCheckboxGroup };
//# sourceMappingURL=checkbox-group.js.map